import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { SafeHtmlPipe } from 'src/app/templates/safe.pipe';
import { ContentService } from '../../../services/content.service';

@Component({
  selector: 'app-team-profile-characteristics',
  templateUrl: './team-profile-characteristics.component.html',
  styleUrls: ['./team-profile-characteristics.component.scss', '../../../../styles/templates/_purple-pulsing-cards.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [CommonModule, SafeHtmlPipe],
})
export class TeamProfileCharacteristicsComponent implements OnInit {
  @Input() mbtiType: string;
  isApiDataLoaded: boolean = false;
  reportContent: string;

  constructor(private contentService: ContentService) {}

  ngOnInit() {
    this.contentService.getReport('TeamsTeamCharacteristics', this.mbtiType).subscribe((data) => {
      this.reportContent = data.content;
      this.isApiDataLoaded = true;
    });
  }
}
